var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function formatGeoDealsAndMarkers(deals) {
    var geoDeals = [];
    var geoMarkers = [];
    deals.forEach(function (deal, index) {
        var location = deal.location;
        geoDeals.push(__assign(__assign({}, deal), { index: index + 1 }));
        geoMarkers.push({
            index: index + 1,
            id: location.uuid,
            coordinate: {
                latitude: location.lat,
                longitude: location.lng
            }
        });
    });
    return { geoDeals: geoDeals, geoMarkers: geoMarkers };
}
